import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { ComponentRegistration } from '../core';
import { Dto, IParkingAreaResource } from '../data';
let template = require('./parking-area.html');

class ParkingAreaComponent extends ComponentRegistration {

    constructor() {
        super('parkingArea', {
            controller: ParkingAreaController,
            templateUrl: template,
            controllerAs: 'parkingArea',
            bindings: {
                preferredSelected: "=?",
                preferred: '=?',
                alternate: "=?",
                alternateSelected: "=?",
                ngDisabled: "=?",
                required: '=?',
                form: "&"
            }
        });
    }
}

interface IParkingAreaController {
    onPreferredChange(): void;
    onAlternateChange(): void;
    loadParkingAreas(): any;
}

interface IParkingAreaFormController extends ng.IFormController {
    parkingAreaPrimary: ng.IFormController;
    parkingAreaSecondary: ng.IFormController;
}

class ParkingAreaController implements IParkingAreaController {
    private static $inject: Array<string> = ["$scope", "ParkingArea"];

    //private fields
    private parkingAreas: Array<Dto.IParkingArea> = [];
    private selectedPrimary: any = {};
    private selectedSecondary: any = {};
    private useSecondary: Boolean = false;
    private hostForm: IParkingAreaFormController;
    private isLoading: Boolean;

    //bindings
    private preferredSelected: Dto.IParkingArea;
    private preferred: string;
    private alternate: string;
    private alternateSelected: Boolean;
    private ngDisabled: Boolean;
    private required: Boolean;
    private form: Function;

    constructor(private $scope: ng.IScope,
        private ParkingArea: IParkingAreaResource) {

        console.log("ParkingArea controller loaded.");

    }

    public $onInit(): void {
        this.preferred = this.preferred || '';
        this.alternate = this.alternate || '';
        this.ngDisabled = this.ngDisabled || false;
        this.required = this.required || false;

        this.hostForm = this.form();
        if (!this.hostForm)
            throw "Form reference was not resolved by the execution of the expression.";

        this.loadParkingAreas()
            .then(() => {
                this.onPreferredChange();
                this.onAlternateChange();
            });

        console.log("ParkingArea controller activated.");
    }

    public onPreferredChange(): void {
        this.selectedPrimary = Linq.From(this.parkingAreas)
            .FirstOrDefault((x) => { return x.id === this.preferred; });
        this.preferredSelected = this.selectedPrimary;
    }

    public onAlternateChange(): void {
        this.selectedSecondary = Linq.From(this.parkingAreas)
            .FirstOrDefault( (x) => { return x.id === this.alternate; });
        this.alternateSelected = this.selectedSecondary;
    }

    public loadParkingAreas(): any {
        this.isLoading = true;
        return this.ParkingArea.query({})
            .$promise
            .then((response): any => {
                this.parkingAreas = response;
            })
            .catch((e) => {
                console.log(e);
            });
    }

}

let pareaComponent = new ParkingAreaComponent();
export default pareaComponent;
export { pareaComponent as ParkingAreaComponent, IParkingAreaController, ParkingAreaController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/parking-area.ts